import React, {useState, useEffect} from 'react'
import _ from 'lodash'
import HTMLField from './HTMLField'

const StepEditForm = props => {
  //content comes from AJAX load, step is based on selectedStep props
  const [commitStatus, setCommitStatus] = useState('not-started');
  const [openStatus, setOpenStatus] = useState({});

  const step = ((props.contentData || {}).steps || [])[props.stepIndex];


  const setValue = (propertyPath, value, obj) => {
    console.log('setting', propertyPath, obj)

    // https://medium.com/data-scraper-tips-tricks/safely-read-write-in-deeply-nested-objects-js-a1d9ddd168c6

    // this is a super simple parsing, you will want to make this more complex to handle correctly any path
    // it will split by the dots at first and then simply pass along the array (on next iterations)
    let properties = Array.isArray(propertyPath) ? propertyPath : propertyPath.split(".")

    // Not yet at the last property so keep digging
    if (properties.length > 1) {
      // The property doesn't exists OR is not an object (and so we overwritte it) so we create it
      if (!obj.hasOwnProperty(properties[0]) || typeof obj[properties[0]] !== "object") obj[properties[0]] = {}
      // We iterate.
      return setValue(properties.slice(1), value, obj[properties[0]])
      // This is the last property - the one where to set the value
    } else {
      // We set the value to the last property
      obj[properties[0]] = value
      return true // this is the end
    }

  }

  const getValue = (propertyPath, obj) => {
    console.log('searching', propertyPath, obj)
    // https://medium.com/data-scraper-tips-tricks/safely-read-write-in-deeply-nested-objects-js-a1d9ddd168c6

    // this is a super simple parsing, you will want to make this more complex to handle correctly any path
    // it will split by the dots at first and then simply pass along the array (on next iterations)
    let properties = Array.isArray(propertyPath) ? propertyPath : propertyPath.split(".")

    // Not yet at the last property so keep digging
    if (properties.length > 1) {
      // The property doesn't exists OR is not an object (and so we overwritte it) so we create it
      if (!obj.hasOwnProperty(properties[0]) || typeof obj[properties[0]] !== "object") obj[properties[0]] = {}
      // We iterate.
      return getValue(properties.slice(1), obj[properties[0]])
      // This is the last property - the one where to set the value
    } else {
      return obj[properties[0]] // this is the end
    }

  }

  const generateInputAndLabel = (data, key) => {
    return <tr>
      <td className={`value`}>
        {genericInput(data, key)}
      </td>
    </tr>
  }

  const generateInputNoLabel = (data, key) => {
    return <tr>
      <td className={`value`}>
        {genericInput(data, key)}
      </td>
    </tr>
  }

  const toggleOpen = (keys) => {
    let temp = _.cloneDeep(openStatus);
    let cv = getValue(keys, temp);
    if (cv === undefined) cv = {};
    if (cv.editorOpen === undefined) cv.editorOpen = true;
    cv.editorOpen = !cv.editorOpen;
    console.log('toggling', keys, cv.editorOpen);
    setValue(keys, cv, temp)
    setOpenStatus(temp);
  }

  const insertMember = (keys) => {
    console.log('inserting ', keys)
    let tempStep = _.cloneDeep(step);
    let parentAddress = _.cloneDeep(keys);
    parentAddress.splice(parentAddress.length - 1);
    let cloneMe = _.cloneDeep(getValue(keys, tempStep));
    console.log('inserting clone of', cloneMe);
    let parent = _.cloneDeep(getValue(parentAddress, tempStep));
    console.log('into', parent)
    parent.splice(keys[keys.length - 1], 0, cloneMe);
    setValue(parentAddress, parent, tempStep);
    let tempContent = _.cloneDeep(props.contentData);
    tempContent.steps[props.stepIndex] = tempStep;
    props.controller.setContentData(tempContent);
    props.controller.forceRender();
  }

  const removeMember = (keys) => {
    console.log('removing ', keys)
    let tempStep = _.cloneDeep(step);
    let parentAddress = _.cloneDeep(keys);
    parentAddress.splice(parentAddress.length - 1);
    let parent = _.cloneDeep(getValue(parentAddress, tempStep));
    console.log('into', parent)
    parent.splice(keys[keys.length - 1], 1);
    setValue(parentAddress, parent, tempStep);
    let tempContent = _.cloneDeep(props.contentData);
    tempContent.steps[props.stepIndex] = tempStep;
    props.controller.setContentData(tempContent);
    props.controller.forceRender();
  }

  const genericInput = (data, keys, parentIsArray) => {
    if (typeof data === 'string') {
      if (/<\/?[a-z][\s\S]*>/i.test(data)) {
        // contains HTML
        return <div className="entry">
          <span className={`label`}>{keys[keys.length - 1]}</span>
          <span className={`value`}>
                    <HTMLField val={data} onChange={(value) => handleFormChange(keys, value)}/>
                </span>
        </div>

      }
      return <div className="entry">
        <span className={`label`}>{keys[keys.length - 1]}</span>

        <span className={`value`}>
                    <input type="text" value={data} onChange={(e) => handleFormChange(keys, e.currentTarget.value)}/>
                </span>
      </div>
    }
    if (typeof data === 'number') {
      return <div className="entry">
        <span className={`label`}>{keys[keys.length - 1]}</span>

        <span className={`value`}>
                    <input type="number" value={data} onChange={(e) => handleFormChange(keys, e.currentTarget.value)}/>
                </span>
      </div>
    }
    if (typeof data === 'boolean') {
      return <div className="entry">
        <span className={`label`}>{keys[keys.length - 1]}</span>

        <span className={`value`}>
                    <input type="checkbox" checked={data} onChange={(e) => handleFormChangeCheckbox(keys)}/>
                </span>
      </div>
    }
    if (typeof data === 'object') {
      //check if array
      if (Array.isArray(data)) {
        //add plus button
        return <div
          className={`entry object ${(getValue(keys, openStatus) || {}).editorOpen === false ? 'closed' : 'open'}`}>
          <span className={`label`} onClick={() => toggleOpen(keys)}>{keys[keys.length - 1]}</span>

          <span>
                        {recursiveDecodeObject(data, keys, true)}
                    </span>
        </div>
      }
      if (parentIsArray) {
        return <div
          className={`entry object ${(getValue(keys, openStatus) || {}).editorOpen === false ? 'closed' : 'open'}`}>
                    <span className={`label`} onClick={() => toggleOpen(keys)}>{keys[keys.length - 1]}
                      <div className={`add-member editor-button`} onClick={() => insertMember(keys)}>+</div>
                    <div className={`remove-member editor-button`} onClick={() => removeMember(keys)}>-</div></span>

          <span>
                        {recursiveDecodeObject(data, keys)}
                    </span>

        </div>
      }
      //break out into loop
      return <div
        className={`entry object ${(getValue(keys, openStatus) || {}).editorOpen === false ? 'closed' : 'open'}`}>
        <span className={`label`} onClick={() => toggleOpen(keys)}>{keys[keys.length - 1]}</span>

        <span>
                    {recursiveDecodeObject(data, keys)}
                </span>
      </div>
    }
  }

  const recursiveDecodeObject = (data, keys, parentIsArray = false) => {
    if (typeof data !== 'object') return <></>;
    // console.log('decoding ', data);
    if (!keys) {
      return Object.keys(data).map(key => {
        let temp = [];
        temp.push(key);
        return genericInput(data[key], temp)
      })
    } else {
      return Object.keys(data).map(key => {
        let temp = _.cloneDeep(keys);
        temp.push(key);
        return genericInput(data[key], temp, parentIsArray)
      })
    }

  }

  const handleFormChange = (keys, value) => {
    console.log('keys, val', keys, value);
    let tempStep = _.cloneDeep(step);
    if (!setValue(keys, value, tempStep)) {
      console.log('setvalue error');
    }

    let tempContent = _.cloneDeep(props.contentData);
    tempContent.steps[props.stepIndex] = tempStep;
    props.controller.setContentData(tempContent);
    props.controller.forceRender();

  }

  const handleFormChangeCheckbox = (keys) => {
    console.log('keys, val', keys);

    let tempStep = _.cloneDeep(step);
    if (!setValue(keys, !getValue(keys, tempStep), tempStep)) {
      console.log('setvalue error');
    }

    let tempContent = _.cloneDeep(props.contentData);

    tempContent.steps[props.stepIndex] = tempStep;
    props.controller.setContentData(tempContent);
    props.controller.forceRender();

  }


  const commitChanges = () => {
    props.commitChanges();
  }

  return (
    <div className="StepEditForm">
      {step &&

      <div className={`step`}>
        <table>
          <tbody>
          {recursiveDecodeObject(step)}
          </tbody>
        </table>
        <div className="editor-button" onClick={commitChanges}>{props.saving.message}</div>
      </div>

      }
    </div>
  )
}

export default StepEditForm